if (!customElements.get('video-banner')) {
  class VideoBanner extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('[data-video]');

      if (this.querySelector('[data-play-button]')) {
        this.playButton = this.querySelector('[data-play-button]');
        this.playButton.addEventListener('click', this.toggleVideo.bind(this));
      }
    }

    toggleVideo() {
      this.video.play();
      this.video.parentElement.classList.add('is-playing');

      if (!this.video.hasAttribute('controls')) {
        this.video.addEventListener('click', () => {
          this.video.pause();
          this.video.parentElement.classList.remove('is-playing');
        });
      }
    }
  }

  window.VideoBanner = VideoBanner;
  customElements.define('video-banner', VideoBanner);
}
